var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditCardAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 13.3346H7.00065C4.49465 13.3346 3.24198 13.3346 2.40532 12.6746C2.27236 12.5693 2.14878 12.4527 2.03598 12.326C1.33398 11.5393 1.33398 10.3593 1.33398 8.0013C1.33398 5.6433 1.33398 4.46397 2.03598 3.67664C2.14843 3.55041 2.27154 3.43441 2.40532 3.32864C3.24198 2.66797 4.49465 2.66797 7.00065 2.66797H9.00065C11.5067 2.66797 12.7593 2.66797 13.5953 3.32797C13.7295 3.43464 13.8529 3.55086 13.9653 3.67664C14.598 4.38597 14.6607 5.4133 14.6673 7.33464M1.33398 6.0013H14.6673M9.33398 12.0013C9.33398 12.0013 10.0007 12.0013 10.6673 13.3346C10.6673 13.3346 12.7853 10.0013 14.6673 9.33464",
    stroke: "#EEF3F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCardAccept);
export default __webpack_public_path__ + "static/media/IconCreditCardAccept.04ab22d272491e6388ed79503b605059.svg";
export { ForwardRef as ReactComponent };